import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { markup } from "./configurationMarkdown";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfigurationMarkdown',
    props: {
        markdown: null,
        admin: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const markdownHtml = computed(() => { var _a; return markup((_a = props.markdown) !== null && _a !== void 0 ? _a : "", props.admin); });
        return { __sfc: true, props, markdownHtml };
    }
});
